import * as React from 'react';

import { SvgButton, color } from '@coursera/coursera-ui';
import { SvgWindows } from '@coursera/coursera-ui/svg';

import { TooltipWrapper } from 'bundles/common/components/Tooltip';

import _t from 'i18n!nls/authoring';

type Props = {
  value: string;
  tooltipMessage?: string;
  copiedMessage?: string;
  disabled?: boolean;
  className?: string;
};

type State = {
  copied: boolean;
};

class CopyToClipboardButton extends React.Component<Props, State> {
  declare buttonRef?: HTMLButtonElement | null;

  declare copySourceRef?: HTMLTextAreaElement | null;

  state = {
    copied: false,
  };

  copyToClipboard = () => {
    if (this.copySourceRef && this.buttonRef) {
      this.copySourceRef.focus();
      this.copySourceRef.select();
      document.execCommand('copy');
      this.buttonRef.focus();
      this.setState({ copied: true });
    }
  };

  unsetCopyState = () => {
    this.setState({ copied: false });
  };

  render() {
    const { className, tooltipMessage, copiedMessage, disabled, value } = this.props;
    const { copied } = this.state;

    const message = copied ? copiedMessage || _t('Copied!') : tooltipMessage || _t('Copy to Clipboard');
    return (
      <span className="rc-CopyToClipboardButton" onMouseLeave={this.unsetCopyState}>
        <TooltipWrapper message={message}>
          <SvgButton
            rootClassName={className}
            _refAlt={(ref) => {
              this.buttonRef = ref;
            }}
            disabled={disabled}
            size="sm"
            onClick={this.copyToClipboard}
            svgElement={<SvgWindows size={16} color={color.primaryText} hoverColor={color.white} />}
          />
          <textarea
            ref={(ref) => {
              this.copySourceRef = ref;
            }}
            className="sr-only copySource"
            aria-hidden={true}
            value={value}
          />
        </TooltipWrapper>
      </span>
    );
  }
}

export default CopyToClipboardButton;
